import { CustomerAPI } from 'api'

export const getIntegrationStates = async () => {
  return CustomerAPI.get(`/integrations`).then((response) => response.data)
}
